/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router";
import CommonContext from "../../hooks/commonContext";
import { Container } from "@material-ui/core";
import PageTitle from "../../components/pageTitle/PageTitle";
import { getFormatedDate } from "../../services/helpers";
import {
  getChannelList,
} from "../../services/apiservices/messages";
import { useMediaQuery } from "@mui/material";
import AuthContext from "../../hooks/authContext";
import { Input } from "../../components/ui/input";
import { Eye, Globe, Lock, MessageSquare, MoreVertical, Plus, Search, Users } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Badge } from "../../components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger  } from "../../components/ui/dropDown";

  const ActionDropdown = ({ channelId , redirectToChannelDetails}) => (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-32 bg-white dark:bg-[#1A1F2C]" style={{zIndex:"9999px"}}>
        <DropdownMenuItem
          className="cursor-pointer dark:text-white">
          <Eye className="h-4 w-4 mr-8 dark:text-white" onClick={() => redirectToChannelDetails(channelId)}/>
          View
        </DropdownMenuItem>
        {/* <DropdownMenuItem className="cursor-pointer">
          <Edit className="h-4 w-4 mr-8" onClick={() => redirectToCreateChannel(channelId)}/>
          Edit
        </DropdownMenuItem>
        <DropdownMenuItem className="cursor-pointer text-destructive">
          <Trash2 className="h-4 w-4 mr-8" onClick={() => handleDialogOpen(channel)} />
          Delete
        </DropdownMenuItem> */}
      </DropdownMenuContent>
    </DropdownMenu>
  );

const ManageChannels = (props) => {
  const commonContext = useContext(CommonContext);
  const history = useNavigate();
  const [allChannels, setAllChannels] = React.useState([]);
  const [searchTerm, setsearchTerm] = React.useState("");
  const isMobile = useMediaQuery('(max-width:767px)');
  const isLandscape = useMediaQuery('(min-width: 771px) and (max-width: 940px)');
  const auth = useContext(AuthContext);
  const companyId = auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;

  const fetchChannelList = async () => {
    getChannelList(companyId,
      (res) => {
        if (res) {
          const response = res?.filter((item)=> item.status !== false);
          const user = auth?.userProfile;
          const isEmployee = Array.isArray(user?.role) ? user.role.includes("Employee") : user?.role === "Employee";
          const isClient = user?.role === "Client";
          const isAdminOrCompanyUser = user?.role === "companyUser";
          const isEmployeeAdmin = isEmployee && user?.employeerole === "Admin";

          const publicChannels = response?.filter((item) => item?.type === "Public");
          const privateChannels = response?.filter((item) => {
              if (item?.type !== "Private") return false;

              if (isAdminOrCompanyUser) {
                return true;
              }

              if (isEmployeeAdmin) {
                return true;
              }

              if (isEmployee && user?.employeerole !== "Admin") {
                return (
                  Array.isArray(item?.employee) &&
                  item?.employee?.some((emp) => emp?.id === user?.id)
                );
              }

              if (isClient) {
                return (
                  item?.clientChannel === true &&
                  item?.client === user?.id
                );
              }

              return false;
            });

          const data = [...publicChannels, ...privateChannels];
          setAllChannels(data);
        } else {
          setAllChannels();
        }
      },
      (resError) => {
        console.log("reserror", resError);
      }
    );
  };
  useEffect(() => {
    fetchChannelList();
  }, []);


  const redirectToCreateChannel = (chId) => {
    if (typeof chId !== "undefined" && chId !== "")
      history("/communications/message-board/create-channel/" + chId);
    else history("/communications/message-board/create-channel");
  };

  const redirectToChannelDetails = (chId) => {
      history("/communications/message-board/manage-channel/" + chId);
  };

  const checkRowSearch = (searchTerm, row) => {
    return (
      String(row.description)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase()) ||
      String(row.type)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase()) ||
      String(row.groupName)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase())
    );
  };
  const filteredList =
    searchTerm !== ""
      ? allChannels?.filter((item) => checkRowSearch(searchTerm, item))
      : allChannels;

  
  const getVisibilityIcon = (visibility) => {
    switch (visibility) {
      case "Public":
        return <Globe className="h-3 w-3" />;
      case "Private":
        return <Lock className="h-3 w-3" />;
      default:
        return <Users className="h-3 w-3" />;
    }
  };

  const getVisibilityColor = (visibility) => {
    switch (visibility) {
      case "Public":
        return "bg-green-100 text-green-800 border-green-200";
      case "Private":
        return "bg-red-100 text-red-800 border-red-200";
      default:
        return "bg-blue-100 text-blue-800 border-blue-200";
    }
  };

  return (
    <>
      <Container>
        <PageTitle
          pageTitle="Channels"
          showBreadcrumb={[
            { label: "Home", to: "/" },
            { label: "Communications" },
          ]}
          BreadCrumbCurrentPageTitle={"Manage Channels"}
          showLastSeen={true}
          {...(!(Array.isArray(auth?.userProfile?.role) ? auth.userProfile.role.includes("admin") && !auth.userProfile.role.includes("Employee") : auth?.userProfile?.role === "admin") && {
            buttonTitle: "Create New Channel",
            icons: <Plus className="h-4 w-4 mr-5" />,
            buttonClass: "d-flex flex-center",
            buttonStyle: {
              color: "white",
              backgroundColor: "#16A34A",
              padding: "8px 16px",
              borderRadius: "5px",
            },
            buttonClick: () => redirectToCreateChannel(),
          })}
        />

    
    <div className="min-h-screen dark:bg-[#1A1F2C]">
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 dark:bg-none">
        <div className="mx-auto px-3 sm:px-4 lg:px-8 py-4 lg:py-6 max-w-7xl dark:bg-[#1A1F2C]">
          {/* Header Section - Mobile Optimized */}
          <div className="mb-16 sm:mb-24">
            <div className="flex flex-space-between gap-3 sm:gap-4">
              <div className="text-left">
                <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900 dark:text-white">
                  Channel Management
                </h1>
                <p className="text-xs sm:text-sm lg:text-base text-muted-foreground mt-4">
                  Organize and manage your communication channels
                </p>
              </div>
            </div>
          </div>

          {/* Search and Stats Section - Mobile Optimized */}
          <div className="mb-16 sm:mb-24">
            <Card className="border-0 shadow-md dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] p-16">
              <CardContent className="p-3 sm:p-4">
                <div className="space-y-3 sm:space-y-4">
                  {/* Search Bar */}
                  <div className="relative">
                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                    <Input
                      type="search"
                      placeholder="Search channels..."
                      value={searchTerm}
                      onChange={(e) => setsearchTerm(e.target.value)}
                      className="pl-40 h-9 sm:h-10 text-sm"
                    />
                  </div>
                  
                  {/* Stats - Mobile Stack */}
                  <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
                    <div className="flex items-center gap-2 px-3 py-2 rounded-lg text-left" style={{backgroundColor:"#157F3C1A"}}>
                      <MessageSquare className="h-4 w-4 text-primary flex-shrink-0" />
                      <span className="text-sm font-medium">{filteredList?.length} Channels</span>
                    </div>
                    <div className="flex items-center gap-2 px-3 py-2 bg-green-50 dark:bg-[#157F3C1A] rounded-lg text-left">
                      <Users className="h-4 w-4 text-green-600 flex-shrink-0" />
                      <span className="text-sm font-medium">{filteredList?.reduce((sum, ch) => sum + ch?.employee?.length, 0)} Members</span>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
            {/* Channels Section */}
          <Card className="border-0 shadow-md dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
            <CardHeader className="pb-12 px-3 sm:px-4 pt-12 sm:pt-16">
              <CardTitle className="text-base sm:text-lg font-semibold text-gray-900 flex items-center gap-2 text-left dark:text-white">
                <MessageSquare className="h-4 sm:h-5 w-4 sm:w-5 text-primary dark:text-green" />
                Channels Overview
              </CardTitle>
            </CardHeader>
            <CardContent className="p-0">
              {filteredList?.length === 0 ? (
                <div className="p-24 sm:p-32 text-center">
                  <MessageSquare className="mx-auto h-10 sm:h-12 w-10 sm:w-12 text-muted-foreground mb-12" />
                  <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-8 dark:text-white">No channels found</h3>
                  <p className="text-muted-foreground mb-16 text-sm">
                    {searchTerm ? "Try adjusting your search terms" : "Get started by creating your first channel"}
                  </p>
                  {!searchTerm && (
                    <Button 
                      size="default"
                      className="bg-[#16A34A] hover:bg-primary/90 h-9 sm:h-10"
                      onClick={() => redirectToCreateChannel()}
                    >
                      <Plus className="mr-8 h-4 w-4" />
                      Create Your First Channel
                    </Button>
                  )}
                </div>
              ) : (
                <div>
                  {/* Desktop Table View */}
                  <div className="hidden lg:block">
                    <Table>
                      <TableHeader className='dark:bg-[#1A1F2C]'>
                        <TableRow className="bg-slate-50/50 dark:bg-[#1A1F2C]">
                          <TableHead className="font-semibold text-gray-900 dark:text-gray-100 text-left">Channel</TableHead>
                          <TableHead className="font-semibold text-gray-900 dark:text-gray-100 text-left">Description</TableHead>
                          <TableHead className="font-semibold text-gray-900 dark:text-gray-100 text-left w-24">Members</TableHead>
                          <TableHead className="font-semibold text-gray-900 dark:text-gray-100 text-left w-28">Visibility</TableHead>
                          <TableHead className="font-semibold text-gray-900 dark:text-gray-100 text-left w-32">Last Activity</TableHead>
                          <TableHead className="font-semibold text-gray-900 dark:text-gray-100 text-center w-24">Actions</TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody className='dark:bg-[#1A1F2C]'>
                        {filteredList?.map((channel) => (
                          <TableRow
                            key={channel?.id} 
                            className="hover:bg-[#f8fafc] transition-colors dark:bg-[#1A1F2C] bg-white"
                          >
                            <TableCell className="py-3">
                              <div className="flex items-center gap-3 text-left">
                                <div className="p-8 bg-primary/10 rounded-lg flex-shrink-0">
                                  <MessageSquare className="h-4 w-4 text-primary" />
                                </div>
                                <div className="min-w-0">
                                  <div className="font-semibold text-gray-900 dark:text-gray-100">
                                    {channel?.groupName}
                                  </div>
                                </div>
                              </div>
                            </TableCell>
                            <TableCell className="py-3 text-left">
                              <p className="text-sm text-gray-600 line-clamp-2 dark:text-gray-100">
                                {channel?.description}
                              </p>
                            </TableCell>
                            <TableCell className="py-3 text-left">
                              <div className="flex items-center gap-2">
                                <Users className="h-4 w-4 text-gray-500" />
                                <span className="font-medium text-gray-700 dark:text-gray-100">
                                  {channel?.employee?.length}
                                </span>
                              </div>
                            </TableCell>
                            <TableCell className="py-3 text-left">
                              <Badge
                                variant="outline" 
                                className={`${getVisibilityColor(channel?.type)} text-xs`}
                                style={{borderRadius:"6px"}}
                              >
                                {getVisibilityIcon(channel?.type)}
                                <span className="ml-4 dark:text-gray-500">{channel?.type}</span>
                              </Badge>
                            </TableCell>
                            <TableCell className="py-3 text-left">
                              <span className="text-sm text-gray-600 dark:text-gray-100">
                                {getFormatedDate(channel?.updatedAt)}
                              </span>
                            </TableCell>
                            <TableCell className="py-3">
                              <div className="flex items-center justify-center gap-1">
                                <Button 
                                  variant="ghost" 
                                  size="sm" 
                                  style={{color:"green"}}
                                  className="h-8 w-8 p-0"
                                  onClick={() => redirectToChannelDetails(channel?.id)}
                                >
                                  <Eye className="h-4 w-4 text-primary" />
                                </Button>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>

                  {/* Mobile/Tablet Optimized Cards */}
                  <div className="lg:hidden space-y-3 p-12 sm:p-16">
                    {filteredList?.map((channel) => (
                      <Card key={channel?.id} className="border border-gray-200 dark:border-0">
                        <CardContent className="p-12 sm:p-4">
                          {/* Header Row */}
                          <div className="flex items-start justify-between mb-12">
                            <div className="flex items-center gap-3 flex-1 min-w-0">
                              <div className="p-8 bg-primary/10 rounded-lg flex-shrink-0"  style={{backgroundColor:"#157F3C1A"}}>
                                <MessageSquare className="h-4 w-4 text-primary" />
                              </div>
                              <div className="min-w-0 flex-1 text-left">
                                <h3 className="font-semibold text-gray-900 text-base sm:text-lg leading-tight dark:text-white">
                                  {channel?.groupName}
                                </h3>
                              </div>
                            </div>
                            {/* Action Dropdown */}
                            <div className="ml-8 flex-shrink-0">
                              <ActionDropdown channelId={channel?.id} redirectToChannelDetails={redirectToChannelDetails}/>
                            </div>
                          </div>
                          
                          {/* Description */}
                          <p className="text-sm text-gray-600 mb-12 text-left leading-relaxed">
                            {channel?.description}
                          </p>
                          
                          {/* Bottom Info Row */}
                          <div className="flex items-center justify-between text-sm">
                            <div className="flex items-center gap-3 sm:gap-4 text-left">
                              <div className="flex items-center gap-1">
                                <Users className="h-4 w-4 text-gray-500" />
                                <span className="text-gray-700 font-medium">{channel?.employee?.length}</span>
                              </div>
                              <Badge 
                                variant="outline" 
                                style={{borderRadius:"6px"}}
                                className={`${getVisibilityColor(channel?.type)} text-xs`}
                              >
                                {getVisibilityIcon(channel?.type)}
                                <span className="ml-4">{channel?.type}</span>
                              </Badge>
                            </div>
                            <span className="text-gray-500 text-xs text-right">
                              {getFormatedDate(channel?.updatedAt)}
                            </span>
                          </div>
                        </CardContent>
                      </Card>
                    ))}
                  </div>
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
      </Container>
    </>
  );
};
export default ManageChannels;
